import { Component, OnInit, ViewChild, TemplateRef, ViewContainerRef } from '@angular/core';
import { LaboursService } from './labours.service';
import { SelectStepsComponent, AgActionCellRendererComponent, AgSelectActionCellRendererComponent } from '../../core/components';
import { ModalConfig, BackdropColor, ModelDialogClass, ModalSize } from '../../core/components/select-steps/select-steps-model/select-steps.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GridApi, GridOptions } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GLOBAL } from 'src/app/app.globals';
import { DynamicApicallService } from 'src/app/service/dynamic-apicall.service';
import { DataShareService } from 'src/app/service/data-share.service';
import { ImportExcelComponent } from '../import-excel/import-excel.component';
import { Subscription } from 'rxjs';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { UploadPhotoComponent } from './upload-photo/upload-photo.component';
import { LabourImportComponent } from '../labour-import/labour-import.component';

@Component({
  selector: 'app-labours',
  templateUrl: './labours.component.html',
  styleUrls: ['./labours.component.css']
})
export class LaboursComponent implements OnInit {
  public labourDetailsForm: FormGroup;
  public totalcount = 0;
  public esicvalue: string;
  public steps: any[];
  @ViewChild(SelectStepsComponent) public templateRef: SelectStepsComponent;
  @ViewChild('templateRef') public templateContent: TemplateRef<any>;
  @ViewChild('uploadPhotoContainer', { read: ViewContainerRef }) container: ViewContainerRef;

  private subscription: Subscription = new Subscription;

  public modalConfig: ModalConfig = {
    backDropColor: BackdropColor.DarkGrey,
    modalWindowClass: ModelDialogClass.CustomClass,
    isCenter: false,
    size: ModalSize.Medium,
    closeOnOutSideClick: false
  };

  applicability: boolean;
  displayContractorOnly: boolean = false;
  isShowSingleBtn: boolean = false;
  isShowAllBtn: boolean = false;
  isuploadPhoto: boolean = false
  isContractor: boolean = false;
  enabledPrePage: boolean = true;
  showModel: boolean = false;
  enabledNextPage: boolean = true;

  defaultColDef;
  gridColumnApi;
  gridApi: GridApi;
  gridOptions: GridOptions = {
    animateRows: true,
    pagination: false,
    rowSelection: 'multiple',
    rowHeight: 40,
    headerHeight: 40,
    context: {
      componentParent: this,
    },
    icons: {
      sortNone: '<i class="fa fa-sort"/>',
      sortAscending: '<i class="fa fa-sort-alpha-asc"/>',
      sortDescending: '<i class="fa fa-sort-alpha-desc"/>'
    }
  };

  FilteredData: any = [];
  filteredRecords: number = 0;
  selectedFilter: string = 'All';
  searchText: string = '';

  public pageSize: number = 50;
  public totalRecords: number = 0;
  public totalPages: number = 0;
  public pageNumber: number = 1;
  private loadedPages: Map<number, any[]> = new Map();


  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private labourService: LaboursService,
    private apiCall: DynamicApicallService,
    private dataShareService: DataShareService,
    private logHelperService: LogHelperService,
  ) {
    const roleCode = GLOBAL.USER.ROLE_CODE;
    this.isContractor = (roleCode === 119);
    this.columnDefs.find(item => item.field === 'ULC').hide = this.isContractor;
  }

  requestPayload = {
    Filter: {
      SearchText: null,
      requestcode: null,
      Contractor_Code: null,
      AadharCardNo: null,
      PanCardNo: null,
      PFNo: null,
      EsicNo: null,
      UANNo: null,
      PageNo: this.pageNumber,
      RowCountPerPage: this.pageSize,
      RequireType: 0,
      ActionType: 0,
      UserId: GLOBAL.USER_ID
    }
  };

  rowData = [];
  columnDefs = [
    {
      headerName: 'Sr No.', field: 'srNo', width: 60,
      sortable: false, suppressMenu: true, pinned: 'left',
    },
    {
      headerName: 'Contractor', field: 'Company', autoHeight: true,
      width: 190, sortable: false, filter: true, pinned: 'left', headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      cellRenderer: function (params) { return '<span class="hover-shadow">' + params.value + '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' + params.value + '></i> </span>' },
      tooltip: (params) => params.value,
    },
    {
      headerName: 'Request No', field: 'GatePassRequest', width: 100,
      suppressMenu: true, pinned: 'left', headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      cellRenderer: function (params) { return '<span class="hover-shadow">' + params.value + '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' + params.value + '></i> </span>' },
      tooltip: (params) => params.value,
    },
    {
      headerName: 'Full Name', field: 'FullName', autoHeight: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      width: 200, sortable: false, filter: true, pinned: 'left',
      cellRenderer: function (params) { return '<span class="hover-shadow">' + params.value + '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' + params.value + '></i> </span>' },
      tooltip: (params) => params.value,
    },
    {
      headerName: 'GatePass No', field: 'GatePassNo', autoHeight: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      width: 90, sortable: false, filter: true, pinned: 'left',
    },
    {
      headerName: 'ULC', field: 'ULC', autoHeight: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      width: 90, sortable: false, filter: true, pinned: 'left',
      hide: this.isContractor
    },
    {
      headerName: 'Gender', field: 'Gender', headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      width: 100, suppressMenu: true
    },
    {
      headerName: 'DOB', field: 'DOB', width: 100, sortable: false, filter: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
    },
    {
      headerName: 'Designation', field: 'TradeName', width: 10, sortable: false, filter: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
    },
    {
      headerName: 'Plant', field: 'Plant', width: 100,
      suppressMenu: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      cellRenderer: function (params) { return '<span class="hover-shadow">' + params.value + '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' + params.value + '></i> </span>' },
      tooltip: (params) => params.value,
    },
    {
      headerName: 'Unit', field: 'Unit', width: 100, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      suppressMenu: true
    },
    {
      headerName: 'Department', field: 'Department', width: 120, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      suppressMenu: true
    },
    {
      headerName: 'Wage Criteria', field: 'strESICWageCriteria', width: 130,
      sortable: false, filter: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      cellRenderer: function (params) { return '<span class="hover-shadow">' + params.value + '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' + params.value + '></i> </span>' },
      tooltip: (params) => params.value,
    },
    {
      headerName: 'ESIC No', field: 'ESICNo', width: 120,
      suppressMenu: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      cellRenderer: function (params) { return '<span class="hover-shadow">' + params.value + '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' + params.value + '></i> </span>' },
      tooltip: (params) => params.value,
    },
    {
      headerName: 'PF No', field: 'PFNo', width: 120,
      suppressMenu: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      cellRenderer: function (params) { return '<span class="hover-shadow">' + params.value + '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' + params.value + '></i> </span>' },
      tooltip: (params) => params.value,
    },
    {
      headerName: 'UAN', field: 'PFUANNo', width: 100,
      suppressMenu: true, headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      cellRenderer: function (params) { return '<span class="hover-shadow">' + params.value + '&nbsp;&nbsp; <i class="fa fa-clipboard" [cdkCopyToClipboard]=' + params.value + '></i> </span>' },
      tooltip: (params) => params.value,
    },
    {
      headerName: 'Action', field: '', width: 100, sortable: false, suppressMenu: true,
      cellRendererFramework: AgActionCellRendererComponent, pinned: 'right', headerClass: 'custom-header', cellClass: 'global-table-cell-text-center',
      cellRendererParams: (params) => ({ isUploadPhoto: true, isDeleteRecord: Array.isArray(this.rowData) && params.data.Request_Code === null, componentParent: this })
    }
  ];

  public numberOfRowsPerPage = 10;
  public gridAPI: GridApi;
  public gridRowData: any[] = [];
  public gridColumnDefs = [
    {
      headerName: '#', field: 'index',
      width: 50,
      valueGetter: (params) => params.node.rowIndex + 1
    },
    {
      headerName: 'CCN', field: 'ContractorVendor_Code',
      width: 150, filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: 'Vendor Code', field: 'ShortCode',
      width: 150, filterParams: { applyButton: true, clearButton: true },
    },
    {
      headerName: 'Contractor / Company', field: 'Company', width: 450, filterParams:
        { applyButton: true, clearButton: true }, sort: 'asc', sortable: true, filter: true
    },
    {
      headerName: 'Email Id', field: 'EmailID', width: 450, filterParams:
        { applyButton: true, clearButton: true }, sortable: true, filter: true
    },
    {
      headerName: 'PAN Nbr.', field: 'PANNo', width: 150, filterParams:
        { applyButton: true, clearButton: true }, sortable: true, filter: true
    },
    {
      headerName: 'Is Sub-Contractor', field: 'IsContactor', width: 150, filterParams:
        { applyButton: true, clearButton: true }, sortable: true, filter: true
    },
    {
      headerName: 'Status', field: 'StatusMasterlist_Code', width: 150, filterParams:
        { applyButton: true, clearButton: true }, sortable: true, filter: true
    },
    {
      headerName: 'Action', field: '', width: 70, filterParams: { applyButton: true, clearButton: true },
      sortable: false, suppressMenu: true, cellRendererFramework: AgSelectActionCellRendererComponent,
    }
  ];

  rowClassRules = {
    'global-table-even-row': (params) => params.node.rowIndex % 2 === 0,
    'global-table-odd-row': (params) => params.node.rowIndex % 2 !== 0,
  };

  ngOnInit() {
    this.dataShareService.shareData({ function: "labourDataImportExcel", type: "saveImportExcel", data: 'ok' });
    this.subscription = this.dataShareService.getData().subscribe((result: any) => {
      if (result.function == 'labourDataImportExcel' && result.type == 'saveImportExcel' && result.data != '')
        this.getLabours();
    });
    if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code === 119) {
      this.displayContractorOnly = true;
    } else {
      this.displayContractorOnly = false;
    }
    this.getLabours();
    this.labourDetailsForm = this.formBuilder.group({
      aadharcard: ['', Validators.required],
      contractorselection: ['', Validators.required],
      applicability: ['', Validators.required],
      labour: ['', Validators.required],
      contractManType: ['', Validators.required],
      nationality: ['', Validators.required],
    });
    // this.labourService.globalSettingCode('').subscribe((res: any) => {
    const globalCode = this.dataShareService.globalCodesArrayDataShareService;
    if (localStorage.RoleCode == '119') {
      let isShowSinglebutton = globalCode.filter((i) => i.Code == 'MOD152PG195IMPEXCELCONSIN');
      this.isShowSingleBtn = isShowSinglebutton[0].Value == "1" ? true : false;

      let isShowAllbutton = globalCode.filter((i) => i.Code == 'MOD152PG195IMPEXCELCONAll');
      this.isShowAllBtn = isShowAllbutton[0].Value == "1" ? true : false;
    } else {
      let isShowSinglebutton = globalCode.filter((i) => i.Code == 'MOD152PG195IMPEXCELHRSIN');
      this.isShowSingleBtn = isShowSinglebutton[0].Value == "1" ? true : false;

      let isShowAllbutton = globalCode.filter((i) => i.Code == 'MOD152PG195IMPEXCELHRAll');
      this.isShowAllBtn = isShowAllbutton[0].Value == "1" ? true : false;
    }
    // });
    this.getAllcontractorData();
  }

  public openModalAction(): void {
    this.templateRef.openModel();
  }

  getLabours(): void {
    this.requestPayload.Filter.PageNo = this.pageNumber;

    this.apiCall.callApi('Common/MultiTableList/GetLabourProfileList_V1', 'POST', { body: this.requestPayload }).subscribe((response) => {
      const startIndex = (this.pageNumber - 1) * this.pageSize;

      this.rowData = response.Table1.map((row, index) => ({
        ...row,
        srNo: startIndex + index + 1,
      }));

      this.FilteredData = this.rowData;
      this.totalRecords = response.Table2[0].TotalRecord;
      this.filteredRecords = this.rowData.length;
      this.loadedPages.set(this.pageNumber, Array.from(this.rowData));
      this.updatePagination();
    });
  }

  private getAllcontractorData(): void {
    this.labourService.getAllContractorData().subscribe((contractorResponse) => {
      if (contractorResponse.length > 0) {
        this.gridRowData = contractorResponse;
      }
      if (contractorResponse.Data) {
        this.gridRowData = contractorResponse.Data.Table;
      }
      this.setStepArray();
    });
  }

  public stepsGridOptions = <GridOptions>{
    context: {
      componentParent: this
    },
    getRowHeight: (params) => {
      return 37;
    },
    // getRowWidth: (params) => {
    //   return 40;
    // },
    onGridReady: (params) => {
      this.gridAPI = params.api;
      params.api.sizeColumnsToFit();
    },
    onGridSizeChanged: (params) => {
      params.api.sizeColumnsToFit();
    },
    icons: {
      sortNone: '<i class="fa fa-sort"/>',
      sortAscending: '<i class="fa fa-sort-alpha-asc"/>',
      sortDescending: '<i class="fa fa-sort-alpha-desc"/>'
    },
    pagination: true,
    paginationPageSize: this.pageSize,
    headerHeight: 40,
  };

  setStepArray(): void {
    if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code === 119) {
      this.steps = [
        // {
        //   id: 2,
        //   type: 'radio',
        //   name: 'Please Aadhar Number.',
        //   title: 'Select Criteria',
        //   button: { skip: false, cancel: false, submit: false, next: true, close: false },
        //   header: true,
        //   footer: true,
        //   formControlName: 'aadharcard',
        //   inputs: [
        //     {
        //       label: 'Aadhar Number',
        //       value: 'Aadhar Number'
        //     },
        //     {
        //       label: 'Aadhar Name',
        //       value: 'Aadhar Name'
        //     },
        //   ]
        // },
        // {
        //   id: 3,
        //   type: 'radio',
        //   name: 'Please select Appropriate Aplicability.',
        //   title: 'Select Criteria',
        //   button: { skip: false, cancel: false, submit: false, next: true, close: false },
        //   header: true,
        //   footer: true,
        //   formControlName: 'applicability',
        //   inputs: [
        //     {
        //       label: 'Wage / Salary < 21000.00',
        //       value: 'Wage / Salary < 21000.00'
        //     },
        //     {
        //       label: 'Wage / Salary ≥ 21000.00)',
        //       value: 'Wage / Salary ≥ 21000.00)'
        //     },
        //   ]
        // },
        // {
        //   id: 4,
        //   type: 'radio',
        //   name: 'Contract man type of category please.',
        //   title: 'Select Criteria',
        //   button: { skip: false, cancel: false, submit: false, prevNext: true, close: false },
        //   header: true,
        //   footer: true,
        //   formControlName: 'contractManType',
        //   inputs: [
        //     {
        //       label: 'CCL',
        //       value: 'CCL'
        //     },
        //     {
        //       label: 'Computer Operator',
        //       value: 'Computer Operator'
        //     },
        //     {
        //       label: 'Other',
        //       value: 'OTHER'
        //     },
        //   ]
        // },
        // {
        //   id: 5,
        //   type: 'radio',
        //   name: 'Please select Nationality?',
        //   title: 'Select Criteria',
        //   button: { skip: false, cancel: false, submit: false, prevNext: true, close: false },
        //   header: true,
        //   footer: true,
        //   formControlName: 'nationality',
        //   inputs: [
        //     {
        //       label: 'Indian',
        //       value: 'INDIAN'
        //     },
        //     {
        //       label: 'Foreigner',
        //       value: 'FOREINER'
        //     },
        //   ]
        // },
        {
          id: 6,
          type: 'navigate',
          routerLink: '/labour/create-sub-labour',
        },
      ];
    } else {
      this.steps = [
        {
          id: 1,
          type: 'grid',
          title: 'Contractor Selection',
          button: { skip: false, cancel: false, submit: false, prev: true, next: true, close: false },
          header: true,
          footer: true,
          columnDef: this.gridColumnDefs,
          rowData: this.gridRowData,
          gridOptions: this.stepsGridOptions,
          formControlName: 'contractorselection'
        },
        // {
        //   id: 2,
        //   type: 'radio',
        //   name: 'Please Aadhar Number.',
        //   title: 'Select Criteria',
        //   button: { skip: false, cancel: false, submit: false, next: true, close: false },
        //   header: true,
        //   footer: true,
        //   formControlName: 'aadharcard',
        //   inputs: [
        //     {
        //       label: 'Aadhar Number',
        //       value: 'Aadhar Number'
        //     },
        //     {
        //       label: 'Aadhar Name',
        //       value: 'Aadhar Name'
        //     },
        //   ]
        // },
        // {
        //   id: 3,
        //   type: 'radio',
        //   name: 'Please select Appropriate Aplicability.',
        //   title: 'Select Criteria',
        //   button: { skip: false, cancel: false, submit: false, next: true, close: false },
        //   header: true,
        //   footer: true,
        //   formControlName: 'applicability',
        //   inputs: [
        //     {
        //       label: 'Wage / Salary < 21000.00',
        //       value: 'Wage / Salary < 21000.00'
        //     },
        //     {
        //       label: 'Wage / Salary ≥ 21000.00)',
        //       value: 'Wage / Salary ≥ 21000.00)'
        //     },
        //   ]
        // },
        // {
        //   id: 4,
        //   type: 'radio',
        //   name: 'Contract man type of category please.',
        //   title: 'Select Criteria',
        //   button: { skip: false, cancel: false, submit: false, prevNext: true, close: false },
        //   header: true,
        //   footer: true,
        //   formControlName: 'contractManType',
        //   inputs: [
        //     {
        //       label: 'CCL',
        //       value: 'CCL'
        //     },
        //     {
        //       label: 'Computer Operator',
        //       value: 'Computer Operator'
        //     },
        //     {
        //       label: 'Other',
        //       value: 'OTHER'
        //     },
        //   ]
        // },
        // {
        //   id: 5,
        //   type: 'radio',
        //   name: 'Please select Nationality?',
        //   title: 'Select Criteria',
        //   button: { skip: false, cancel: false, submit: false, prevNext: true, close: false },
        //   header: true,
        //   footer: true,
        //   formControlName: 'nationality',
        //   inputs: [
        //     {
        //       label: 'Indian',
        //       value: 'INDIAN'
        //     },
        //     {
        //       label: 'Foreigner',
        //       value: 'FOREINER'
        //     },
        //   ]
        // },
        {
          id: 6,
          type: 'navigate',
          // routerLink: '/gate-pass-requests',
          routerLink: '/labour/create-sub-labour',
        },
      ];
    }
  }

  goToPage() {
    if (this.pageNumber <= this.totalPages) {
      this.requestPayload.Filter.PageNo = this.pageNumber;
      this.getLabours();
    } else {
      alert('Invalid page number');
      this.pageNumber = 1
    }
  }

  goToFirstPage() {
    this.pageNumber = 1;
    this.getLabours();
  }

  goToLastPage() {
    this.pageNumber = this.totalPages;
    this.getLabours();
  }

  onPageSizeChange(): void {
    console.log('Selected Page Size:', this.pageSize);
    this.requestPayload.Filter.RowCountPerPage = this.pageSize;
    this.pageNumber = 1;
    this.updatePagination();
    this.getLabours();
  }

  updatePagination(): void {
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
    this.enabledPrePage = this.pageNumber > 1;
    this.enabledNextPage = this.pageNumber < this.totalPages;
  }

  goToNextPage(): void {
    if (this.pageNumber < this.totalPages) {
      this.pageNumber++;

      if (this.loadedPages.has(this.pageNumber)) {
        this.rowData = this.loadedPages.get(this.pageNumber);
        this.updatePagination();
      } else {
        this.getLabours();
      }
    }
  }

  goToPreviousPage(): void {
    if (this.pageNumber > 1) {
      this.pageNumber--;

      if (this.loadedPages.has(this.pageNumber)) {
        this.rowData = this.loadedPages.get(this.pageNumber);
        this.updatePagination();
      } else {
        this.getLabours();
      }
    }
  }

  onSearch(event: Event) {
    const target = event.target as HTMLInputElement;
    this.searchText = target.value;
    this.applyFilters();
  }

  applyFilters() {
    const search = this.searchText.toLowerCase().trim();
    const searchTerms = search.split(',').map((term) => term.trim());
    this.rowData = this.FilteredData.filter((row) => {
      if (this.selectedFilter === 'All') {
        return Object.values(row).some((value) =>
          value ? value.toString().toLowerCase().includes(search) : false
        );
      } else if (this.selectedFilter === 'ULC' || this.selectedFilter === 'GatePassNo') {
        return searchTerms.some((term) =>
          row[this.selectedFilter] ? row[this.selectedFilter].toString().toLowerCase().includes(term) : false
        );
      }
      return false;
    });
    this.filteredRecords = this.rowData.length;
  }

  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getRowNodeId(data: any) {
    return data.id;
  }

  onEdit(rowData) {
    this.router.navigate([`labour/edit-sub-labour/${rowData.Labour_Code}`]);
  }

  onUploadPhoto(rowData) {
    // this.showModel = true;
    // this.labourService.shareData({ function: 'onUploadPhoto', data: rowData, type: 'selectedLabour' });
    const modalRef = this.modalService.open(UploadPhotoComponent,
      { size: 'lg', windowClass: 'modal-scrollbar-hide' });

    modalRef.componentInstance.labourData = rowData;
  }

  onDeleteRecord(rowData) {
    const params = {
      Labour_Code: rowData.Labour_Code,
      RequireType: 1,
      Action: 0,
      RequestedUserId: GLOBAL.USER_ID

    }
    this.apiCall.callApi('Common/List/CLPMS_Delete_Labour_Profile', 'POST', { body: params }).subscribe((response) => {
      // if(){
      //   this.logHelperService.logSuccess({
      //     message: "Success",
      //   });
      // }
    })
  }

  openImportExcel(): void {
    const modalRef = this.modalService.open(ImportExcelComponent,
      { size: 'lg', backdrop: 'static', windowClass: 'modal-panel' },
    );
    // const modalRef = this.modalService.open(LabourImportComponent,
    //   { size: 'lg', backdrop: 'static', windowClass: 'modal-panel' },
    // );
    modalRef.componentInstance.isShowSingleButton = this.isShowSingleBtn;
    modalRef.componentInstance.isShowAllButton = this.isShowAllBtn;
    modalRef.componentInstance.closeModal.subscribe((value: string) => {
      modalRef.close(value);
    });
    modalRef.componentInstance.save.subscribe(() => {
      modalRef.close('');
      this.getLabours();
    });
  }
}
